import styled from 'styled-components';

export const StyledChrome = styled.div`
  max-width: 960px;
  min-height: 100vh;
  margin: ${(p) => p.theme.space[0]} auto;
  display: grid;
  grid-template-columns: repeat(12, ${(p) => p.theme.space[8]});

  @media (max-width: 976px) {
    max-width: unset;
    margin: 0;
    grid-template-columns: 80px 1fr;
  }
`;
